// Does not make any changes to vertices.
// Returns the arguments that are passed to it, unchanged.
export const normal = function(vertices, opt, linkView) {

    return vertices;
};
